import type { TPostElement } from '@shared/dream-components/src';
import { findTipTapContentNode } from '../findTipTapContentNode';

function findPostIdsPostNodes(postNodes: TPostElement[]) {
  const postIds = new Set<string>([]);

  postNodes
    .filter((postNode) => !postNode.attrs.hasFakeData)
    .forEach((postNode) => {
      if (!postNode.attrs.structureTiptapState) {
        return;
      }

      const postActionsNode = findTipTapContentNode(postNode.attrs.structureTiptapState, 'postCardActions');
      if (!postActionsNode) {
        return;
      }

      postNode.attrs.data.posts.forEach((post) => {
        postIds.add(post.id);
      });
    });

  return [...postIds];
}

export { findPostIdsPostNodes };
